import { render, staticRenderFns } from "./bindTable.vue?vue&type=template&id=2c77fa3a&scoped=true&"
import script from "./bindTable.vue?vue&type=script&lang=js&"
export * from "./bindTable.vue?vue&type=script&lang=js&"
import style0 from "./bindTable.vue?vue&type=style&index=0&id=2c77fa3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77fa3a",
  null
  
)

export default component.exports